/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import React from 'react'
import getSvgProps from '../get-svg-props'
function AdsCloseIcon(props) {
  const svgWidth = "32"
  const svgHeight = "32"
  const svgPath = "<path d=\"M5.39 23.78a2 2 0 0 0 2.83 2.83L16 18.83l7.78 7.78a2 2 0 0 0 2.83-2.83L18.83 16l7.78-7.78a2 2 0 1 0-2.83-2.83L16 13.17 8.22 5.39a2 2 0 0 0-2.83 2.83L13.17 16Z\" fill-rule=\"evenodd\"/>"
  return <svg {...getSvgProps({...props, svgWidth, svgHeight, svgPath})} />
}
AdsCloseIcon.defaultProps = {
  defaultClassName: 'eagerlyicon  eagerlyicon-ads-close',
}

function AdsCubeIcon(props) {
  const svgWidth = "128"
  const svgHeight = "128"
  const svgPath = "<path d=\"M102.22 20.27 120 81.58l-57-8.27L45.28 12Z\" fill=\"var(--cube-clr-1, #e7302a)\"/><path d=\"m120 81.58-37.27 34.21-57-8.26L63 73.31Z\" fill=\"var(--cube-clr-2, #b22622)\"/><path d=\"m63 73.31-37.24 34.22L8 46.22 45.27 12Z\" fill=\"var(--cube-clr-3, #cd2b27)\"/>"
  return <svg {...getSvgProps({...props, svgWidth, svgHeight, svgPath})} />
}
AdsCubeIcon.defaultProps = {
  defaultClassName: 'eagerlyicon  eagerlyicon-ads-cube',
}

function AdsCubeRedIcon(props) {
  const svgWidth = "128"
  const svgHeight = "128"
  const svgPath = "<path d=\"M102.22 20.27 120 81.58l-57-8.27L45.28 12Z\" fill=\"#e7302a\"/><path d=\"m120 81.58-37.27 34.21-57-8.26L63 73.31Z\" fill=\"#b22622\"/><path d=\"m63 73.31-37.24 34.22L8 46.22 45.27 12Z\" fill=\"#cd2b27\"/>"
  return <svg {...getSvgProps({...props, svgWidth, svgHeight, svgPath})} />
}
AdsCubeRedIcon.defaultProps = {
  defaultClassName: 'eagerlyicon  eagerlyicon-ads-cube-red',
}

function AdsCubeWhiteIcon(props) {
  const svgWidth = "128"
  const svgHeight = "128"
  const svgPath = "<path d=\"M102.22 20.27 120 81.58l-57-8.27L45.28 12Z\" fill=\"#fff\"/><path d=\"m120 81.58-37.27 34.21-57-8.26L63 73.31Z\" fill=\"#cdcccc\"/><path d=\"m63 73.31-37.24 34.22L8 46.22 45.27 12Z\" fill=\"#e5e5e5\"/>"
  return <svg {...getSvgProps({...props, svgWidth, svgHeight, svgPath})} />
}
AdsCubeWhiteIcon.defaultProps = {
  defaultClassName: 'eagerlyicon  eagerlyicon-ads-cube-white',
}

function AdsDropdownIcon(props) {
  const svgWidth = "32"
  const svgHeight = "32"
  const svgPath = "<path d=\"M7.29 11.29a1 1 0 0 1 1.42 0l7.29 7.3 7.29-7.3a1 1 0 0 1 1.42 1.42l-8 8a1 1 0 0 1-1.42 0l-8-8a1 1 0 0 1 0-1.42Z\" fill-rule=\"evenodd\"/>"
  return <svg {...getSvgProps({...props, svgWidth, svgHeight, svgPath})} />
}
AdsDropdownIcon.defaultProps = {
  defaultClassName: 'eagerlyicon  eagerlyicon-ads-dropdown',
}

function AdsLinkIcon(props) {
  const svgWidth = "32"
  const svgHeight = "32"
  const svgPath = "<path d=\"M23.78 16.11a1 1 0 0 1-1-1v-4.58l-5.27 5.63a1 1 0 1 1-1.46-1.36l5.21-5.58h-4.37a1 1 0 0 1 0-2h6.89a1 1 0 0 1 1 1v6.89a1 1 0 0 1-1 1ZM9.22 9.17a1 1 0 0 0-2 0v14.61a1 1 0 0 0 1 1h14a1 1 0 0 0 0-2h-13Z\" fill-rule=\"evenodd\"/>"
  return <svg {...getSvgProps({...props, svgWidth, svgHeight, svgPath})} />
}
AdsLinkIcon.defaultProps = {
  defaultClassName: 'eagerlyicon  eagerlyicon-ads-link',
}

function AdsLinkedinIcon(props) {
  const svgWidth = "64"
  const svgHeight = "64"
  const svgPath = "<path d=\"M20.38 53h-8.72V25h8.72ZM16 21.19A5.1 5.1 0 0 1 11 16a5 5 0 0 1 7.5-4.32A4.88 4.88 0 0 1 21 16a5.12 5.12 0 0 1-5 5.19ZM52.91 53h-8.63V39.38c0-3.28-.09-7.41-4.59-7.41s-5.16 3.47-5.16 7.13V53h-8.72V25h8.35v3.85h.09a9.33 9.33 0 0 1 8.25-4.5C51.31 24.29 53 30.1 53 37.6V53Z\"/>"
  return <svg {...getSvgProps({...props, svgWidth, svgHeight, svgPath})} />
}
AdsLinkedinIcon.defaultProps = {
  defaultClassName: 'eagerlyicon  eagerlyicon-ads-linkedin',
}

function AdsMenuIcon(props) {
  const svgWidth = "32"
  const svgHeight = "32"
  const svgPath = "<path d=\"M3 4h26a2 2 0 0 1 2 2 2 2 0 0 1-2 2H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2Zm0 10h26a2 2 0 0 1 2 2 2 2 0 0 1-2 2H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2Zm0 10h26a2 2 0 0 1 2 2 2 2 0 0 1-2 2H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2Z\"/>"
  return <svg {...getSvgProps({...props, svgWidth, svgHeight, svgPath})} />
}
AdsMenuIcon.defaultProps = {
  defaultClassName: 'eagerlyicon  eagerlyicon-ads-menu',
}

function AdsSearchIcon(props) {
  const svgWidth = "32"
  const svgHeight = "32"
  const svgPath = "<path d=\"m27.47 24.8-5.62-5.63a9.73 9.73 0 0 0 1.59-6.75 9.9 9.9 0 0 0-8.39-8.34 9.8 9.8 0 0 0-11 11 9.9 9.9 0 0 0 8.34 8.39 9.93 9.93 0 0 0 6.8-1.59l5.58 5.62a1.89 1.89 0 0 0 2.67-2.67ZM7.74 13.74a6 6 0 1 1 6 6 6 6 0 0 1-6-6Z\"/>"
  return <svg {...getSvgProps({...props, svgWidth, svgHeight, svgPath})} />
}
AdsSearchIcon.defaultProps = {
  defaultClassName: 'eagerlyicon  eagerlyicon-ads-search',
}

function AdsTagIcon(props) {
  const svgWidth = "32"
  const svgHeight = "32"
  const svgPath = "<path d=\"m25.71 14.61-8.29-8.3a3.11 3.11 0 0 0-1.88-.8H6.78a1.27 1.27 0 0 0-1.27 1.31v8.72a3.05 3.05 0 0 0 .75 1.88l8.3 8.29a2.58 2.58 0 0 0 3.7 0l7.45-7.45a2.52 2.52 0 0 0 0-3.65Zm-15-2.35a1.43 1.43 0 0 1-1.45-1.45 1.46 1.46 0 0 1 1.45-1.45 1.45 1.45 0 1 1 0 2.9Z\"/>"
  return <svg {...getSvgProps({...props, svgWidth, svgHeight, svgPath})} />
}
AdsTagIcon.defaultProps = {
  defaultClassName: 'eagerlyicon  eagerlyicon-ads-tag',
}

function AdsTagsIcon(props) {
  const svgWidth = "32"
  const svgHeight = "32"
  const svgPath = "<path d=\"M26.88 12 20.5 5.8a1.16 1.16 0 0 0-1.59 0 1.12 1.12 0 0 0 0 1.6l6.33 6.14a4 4 0 0 1 1.22 2.86 3.88 3.88 0 0 1-1.22 2.85l-5.2 5.3a1.08 1.08 0 0 0 0 1.6 1.17 1.17 0 0 0 .8.32 1.34 1.34 0 0 0 .79-.32l5.21-5.3a6.16 6.16 0 0 0 1.87-4.45 6.25 6.25 0 0 0-1.83-4.4Zm-3.43 2.58-8.29-8.3a3.12 3.12 0 0 0-1.88-.79H4.52a1.27 1.27 0 0 0-1.27 1.3v8.72A3 3 0 0 0 4 17.38l8.3 8.3a2.6 2.6 0 0 0 3.7 0l7.45-7.45a2.55 2.55 0 0 0 0-3.66Zm-15-2.34A1.43 1.43 0 0 1 7 10.77a1.46 1.46 0 0 1 1.45-1.45 1.46 1.46 0 1 1 0 2.91Z\"/>"
  return <svg {...getSvgProps({...props, svgWidth, svgHeight, svgPath})} />
}
AdsTagsIcon.defaultProps = {
  defaultClassName: 'eagerlyicon  eagerlyicon-ads-tags',
}

function AdsTwitterIcon(props) {
  const svgWidth = "64"
  const svgHeight = "64"
  const svgPath = "<path d=\"M51.08 22.2v1.32c0 13-9.85 27.93-27.94 27.93a27.44 27.44 0 0 1-15.09-4.4 19 19 0 0 0 2.34.18A19.84 19.84 0 0 0 22.58 43a9.81 9.81 0 0 1-9.19-6.85 12 12 0 0 0 1.88.19A10.87 10.87 0 0 0 17.8 36a9.85 9.85 0 0 1-7.88-9.65v-.1a10.33 10.33 0 0 0 4.5 1.22A9.67 9.67 0 0 1 10 19.3a9.49 9.49 0 0 1 1.31-5 28.58 28.58 0 0 0 20.36 10.34 9.12 9.12 0 0 1-.28-2.25 9.88 9.88 0 0 1 17.06-6.75 20.62 20.62 0 0 0 6.19-2.44 9.61 9.61 0 0 1-4.31 5.44 18.42 18.42 0 0 0 5.67-1.5 20.73 20.73 0 0 1-4.92 5.06Z\"/>"
  return <svg {...getSvgProps({...props, svgWidth, svgHeight, svgPath})} />
}
AdsTwitterIcon.defaultProps = {
  defaultClassName: 'eagerlyicon  eagerlyicon-ads-twitter',
}

function AdsYoutubeIcon(props) {
  const svgWidth = "64"
  const svgHeight = "64"
  const svgPath = "<path d=\"M56.52 19.72a6.42 6.42 0 0 0-4.5-4.6C48 14 32.05 14 32.05 14S16 14 12 15.12a6.42 6.42 0 0 0-4.5 4.6c-1.14 3.94-1.14 12.37-1.14 12.37s0 8.35 1.12 12.38A6.27 6.27 0 0 0 12 49c4 1 20.07 1 20.07 1S48 50 52 49a6.27 6.27 0 0 0 4.5-4.5c1.12-4 1.12-12.38 1.12-12.38s.02-8.46-1.1-12.4Zm-29.72 20V24.5l13.31 7.59Z\"/>"
  return <svg {...getSvgProps({...props, svgWidth, svgHeight, svgPath})} />
}
AdsYoutubeIcon.defaultProps = {
  defaultClassName: 'eagerlyicon  eagerlyicon-ads-youtube',
}

function AgendaIcon(props) {
  const svgWidth = "32"
  const svgHeight = "32"
  const svgPath = "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13 6.5a1.5 1.5 0 0 0-3 0V8H9a4 4 0 0 0-4 4v11a4 4 0 0 0 4 4h13a4 4 0 0 0 4-4V12a4 4 0 0 0-4-4h-1V6.5a1.5 1.5 0 0 0-3 0V8h-5V6.5Zm5 5v-1h-5v1a1.5 1.5 0 0 1-3 0v-1H9A1.5 1.5 0 0 0 7.5 12v3h16v-3a1.5 1.5 0 0 0-1.5-1.5h-1v1a1.5 1.5 0 0 1-3 0Zm5.5 6h-16V23A1.5 1.5 0 0 0 9 24.5h13a1.5 1.5 0 0 0 1.5-1.5v-5.5Z\" fill=\"currentColor\"/>"
  return <svg {...getSvgProps({...props, svgWidth, svgHeight, svgPath})} />
}
AgendaIcon.defaultProps = {
  defaultClassName: 'eagerlyicon  eagerlyicon-agenda',
}

function ArrowIcon(props) {
  const svgWidth = "32"
  const svgHeight = "32"
  const svgPath = "<path d=\"M16.5 31 25 0H8l8.5 31Z\" fill=\"currentColor\"/>"
  return <svg {...getSvgProps({...props, svgWidth, svgHeight, svgPath})} />
}
ArrowIcon.defaultProps = {
  defaultClassName: 'eagerlyicon  eagerlyicon-arrow',
}

function ArrowBtnIcon(props) {
  const svgWidth = "22"
  const svgHeight = "22"
  const svgPath = "<path d=\"m11.225 22-2.48-2.51 6.51-6.646H0V9.156h15.255L8.745 2.52 11.224 0 22 11 11.225 22Z\" fill=\"currentColor\"/>"
  return <svg {...getSvgProps({...props, svgWidth, svgHeight, svgPath})} />
}
ArrowBtnIcon.defaultProps = {
  defaultClassName: 'eagerlyicon  eagerlyicon-arrow-btn',
}

function CloseIcon(props) {
  const svgWidth = "32"
  const svgHeight = "32"
  const svgPath = "<path d=\"M9.161 7.44A1.5 1.5 0 1 0 7.04 9.56l6.617 6.618-7.218 7.217a1.5 1.5 0 1 0 2.122 2.122l7.217-7.218 6.818 6.818a1.5 1.5 0 0 0 2.121-2.121L17.9 16.178l6.217-6.218a1.5 1.5 0 1 0-2.121-2.12l-6.218 6.216L9.161 7.44Z\" fill=\"currentColor\"/>"
  return <svg {...getSvgProps({...props, svgWidth, svgHeight, svgPath})} />
}
CloseIcon.defaultProps = {
  defaultClassName: 'eagerlyicon  eagerlyicon-close',
}

function DividerIcon(props) {
  const svgWidth = "32"
  const svgHeight = "32"
  const svgPath = "<path d=\"M16.5 32 18 0h-3l1.5 32Z\" fill=\"currentColor\"/>"
  return <svg {...getSvgProps({...props, svgWidth, svgHeight, svgPath})} />
}
DividerIcon.defaultProps = {
  defaultClassName: 'eagerlyicon  eagerlyicon-divider',
}

function ErrorIcon(props) {
  const svgWidth = "16"
  const svgHeight = "16"
  const svgPath = "<circle cx=\"8\" cy=\"8\" r=\"8\"/><path d=\"M9.06 4H6.94v2.55l.23 2.78h1.66l.23-2.78ZM8 10c-.72 0-1.15.38-1.15 1s.42 1 1.15 1 1.17-.37 1.17-1-.46-1-1.17-1Z\" fill=\"#fff\"/>"
  return <svg {...getSvgProps({...props, svgWidth, svgHeight, svgPath})} />
}
ErrorIcon.defaultProps = {
  defaultClassName: 'eagerlyicon  eagerlyicon-error',
}

function FilterIcon(props) {
  const svgWidth = "32"
  const svgHeight = "32"
  const svgPath = "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M26.574 5.226h3.878a1.548 1.548 0 1 1 0 3.097h-3.878a4.647 4.647 0 0 1-8.761 0H1.548a1.548 1.548 0 0 1 0-3.097h16.265a4.647 4.647 0 0 1 8.761 0Zm3.878 12.387a1.548 1.548 0 1 0 0-3.097H14.187a4.647 4.647 0 0 0-8.761 0H1.548a1.548 1.548 0 0 0 0 3.097h3.878a4.647 4.647 0 0 0 8.761 0h16.265ZM32 25.355c0 .855-.693 1.548-1.548 1.548h-3.878a4.647 4.647 0 0 1-8.761 0H1.548a1.548 1.548 0 1 1 0-3.096h16.265a4.647 4.647 0 0 1 8.761 0h3.878c.855 0 1.548.693 1.548 1.548Z\" fill=\"currentColor\"/>"
  return <svg {...getSvgProps({...props, svgWidth, svgHeight, svgPath})} />
}
FilterIcon.defaultProps = {
  defaultClassName: 'eagerlyicon  eagerlyicon-filter',
}

function InfoIcon(props) {
  const svgWidth = "16"
  const svgHeight = "16"
  const svgPath = "<circle cx=\"8\" cy=\"8\" r=\"8\"/><path d=\"M8 5.63a1.46 1.46 0 0 1-.91-.23.92.92 0 0 1-.28-.74.91.91 0 0 1 .28-.75A1.4 1.4 0 0 1 8 3.67a1.35 1.35 0 0 1 .9.24.92.92 0 0 1 .29.75.92.92 0 0 1-.29.74 1.41 1.41 0 0 1-.9.23Zm1 6.7H7v-6h2Z\" fill=\"#fff\"/>"
  return <svg {...getSvgProps({...props, svgWidth, svgHeight, svgPath})} />
}
InfoIcon.defaultProps = {
  defaultClassName: 'eagerlyicon  eagerlyicon-info',
}

function LoaderIcon(props) {
  const svgWidth = "100"
  const svgHeight = "100"
  const svgPath = "<path d=\"M0 0h100v100H0z\"/>"
  return <svg {...getSvgProps({...props, svgWidth, svgHeight, svgPath})} />
}
LoaderIcon.defaultProps = {
  defaultClassName: 'eagerlyicon  eagerlyicon-loader',
}

function MenuIcon(props) {
  const svgWidth = "32"
  const svgHeight = "32"
  const svgPath = "<rect x=\"25\" y=\"17\" width=\"19\" height=\"3\" rx=\"1.5\" transform=\"rotate(-180 25 17)\" fill=\"currentColor\"/><rect x=\"25\" y=\"11\" width=\"19\" height=\"3\" rx=\"1.5\" transform=\"rotate(-180 25 11)\" fill=\"currentColor\"/><rect x=\"25\" y=\"23\" width=\"19\" height=\"3\" rx=\"1.5\" transform=\"rotate(-180 25 23)\" fill=\"currentColor\"/>"
  return <svg {...getSvgProps({...props, svgWidth, svgHeight, svgPath})} />
}
MenuIcon.defaultProps = {
  defaultClassName: 'eagerlyicon  eagerlyicon-menu',
}

function SearchIcon(props) {
  const svgWidth = "32"
  const svgHeight = "32"
  const svgPath = "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14.5 6a8.5 8.5 0 1 0 4.3 15.833 1.5 1.5 0 0 0 .26.349l3.536 3.536a1.5 1.5 0 1 0 2.122-2.122l-3.536-3.535a1.491 1.491 0 0 0-.145-.128A8.5 8.5 0 0 0 14.5 6Zm-5.95 8.5a5.95 5.95 0 1 1 11.9 0 5.95 5.95 0 0 1-11.9 0Z\" fill=\"currentColor\"/>"
  return <svg {...getSvgProps({...props, svgWidth, svgHeight, svgPath})} />
}
SearchIcon.defaultProps = {
  defaultClassName: 'eagerlyicon  eagerlyicon-search',
}

function SuccessIcon(props) {
  const svgWidth = "32"
  const svgHeight = "32"
  const svgPath = "<path d=\"M32 16c0 8.837-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0s16 7.163 16 16Z\" fill=\"currentColor\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M24.347 8.765c.682.56.782 1.566.222 2.248L14.117 23.751l-7.132-5.884a1.597 1.597 0 1 1 2.032-2.464l4.663 3.846L22.1 8.987a1.597 1.597 0 0 1 2.247-.222Z\" fill=\"#fff\"/>"
  return <svg {...getSvgProps({...props, svgWidth, svgHeight, svgPath})} />
}
SuccessIcon.defaultProps = {
  defaultClassName: 'eagerlyicon  eagerlyicon-success',
}

export {
  AdsCloseIcon,
  AdsCubeIcon,
  AdsCubeRedIcon,
  AdsCubeWhiteIcon,
  AdsDropdownIcon,
  AdsLinkIcon,
  AdsLinkedinIcon,
  AdsMenuIcon,
  AdsSearchIcon,
  AdsTagIcon,
  AdsTagsIcon,
  AdsTwitterIcon,
  AdsYoutubeIcon,
  AgendaIcon,
  ArrowIcon,
  ArrowBtnIcon,
  CloseIcon,
  DividerIcon,
  ErrorIcon,
  FilterIcon,
  InfoIcon,
  LoaderIcon,
  MenuIcon,
  SearchIcon,
  SuccessIcon
}